module.exports = __webpack_public_path__ + "img/TheGirls.3d05425a.jpg";